<template>
  <div>
    <div class="container">
      <div class="left">
        <div class="BOM-title">  <i class="el-icon-document"></i> {{BOMTitle}} </div>
        <div class="checkbox-group">
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="isTree">树状结构</el-checkbox>
            <!-- <el-checkbox label="isCreate">是否全新创建</el-checkbox>
            <el-checkbox label="isOLd">是否保留旧数据</el-checkbox> -->
          </el-checkbox-group>
        </div>
        <span style="margin-left: 20px;">
          <el-radio-group v-model="isCreate">
            <el-radio :label="1">全新数据</el-radio>
            <el-radio :label="0">保留旧数据</el-radio>
          </el-radio-group>
        </span>
        <div style="padding: 0 " v-loading = 'baseBOMLoading '>
          <vxe-grid ref="xGrid" row-id="serial" v-bind="gridOptions" height="470" :checkbox-config="{ checkStrictly: true , showHeader:true}"  @checkbox-all="selectAllEvent"  @checkbox-change="setCheck"> </vxe-grid>
        </div>
      </div>
      <div class="mid-button" >
        <el-button size="small" class="center-button" type="primary" @click="copyData" :disabled = 'moreBOMLoading || noChecked'>复制</el-button>
      </div>
      <div class="right">
        <el-select v-model="BOMSelected" placeholder="请选择" size="small" @change="getMoreBOM" style=" margin-bottom: 5px;">
          <el-option
            v-for="item in BOMLists"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <span> >> </span>
        <div style="padding: 0 " v-loading="moreBOMLoading">
          <vxe-grid ref="xGridShow" v-bind="copyBOMGridOptions" height="470"> </vxe-grid>
        </div>
      </div>
    </div>
    <div class="button">
      <p style="color:#fff">swift</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {itemTabList} from "@/utils/publicstate";
export default {
  data() {
    return {
      checkList: [],
      isCreate:1,
      BOMLists: [],
      BOMSelected: "",
      BOMTitle:'...BOM',

      tempList:[],

      gridOptions: {
        resizable: true,
        border: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "470",
        size: "small",
        columns: [
          {
            type: "checkbox",
            width: 50,
            fixed: null,
            field:'checked'
          },
        ],
        data: [],
        treeConfig: {
          lazy: true,
          children: "children",
          hasChild: "hasChildren",
        },
        sortConfig: {
          trigger: "cell",
        },
        
      },
      copyBOMGridOptions: {
        resizable: true,
        border: true,
        columns: {},
        data: [],
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        treeConfig: {
          lazy: true,
          children: "children",
          hasChild: "hasChildren",
        },
      },
      objId: {
        ... this.$store.state.objectId,
//id: this.$store.state.objId_,
        //classId: this.$store.state.classId_,
        //subClassId: this.$store.state.subClassId_,
      },
      baseBOMLoading:false,
      moreBOMLoading:false,
      noChecked:true
    };
  },
  props: {
    baseGridOptions: {
      required: true,
      type: Object,
    },
  },
  methods: {
    getBaseBOM() {
      this.baseBOMLoading = true
      const changeInfo = this.get_change_info || this.$store.state.change_info;
      const itemId = this.$store.state.objectId.id;
      const { changeId, changeSubClassId } = changeInfo;
      var obj_get = {
        itemId,
        changeId,
        changeSubClassId,
        tableId: this.$store.state.boms_table_id
      };
      axios
        .get(`/pmdm/MultipleBom/loadMultipleBomTable${this.params(obj_get)}`)
        .then((res) => {
          this.gridOptions.data = this.formatData(res.data.object.rows);
          this.baseBOMLoading = false
        });
    },
    getMoreBOM(){
      this.moreBOMLoading = true
      const itemId = this.$store.state.objectId.id;
      var obj_get = {
        itemId,
        changeId:0,
        changeSubClassId:0,
        tableId: this.BOMSelected
      };
      axios
        .get(`/pmdm/MultipleBom/loadMultipleBomTable${this.params(obj_get)}`)
        .then((res) => {
          this.copyBOMGridOptions.data = this.formatData(res.data.object.rows);
          this.copyBOMGridOptions.columns = res.data.object.columnInfo.names.map((i,e) =>({
            title:i,
            field:e,
            width:120
          }))
          this.copyBOMGridOptions.columns[0].treeNode = true;
          this.moreBOMLoading = false
        });
    },
    getBOMList(){
      axios.get("/pmdm/admin/getTab/" + this.$store.state.objectId.subClassId).then(res =>{
        console.log(res);
        const n = itemTabList.find(j => j.tableId == this.$store.state.boms_table_id).id;
        this.BOMTitle = res.data.object.boms.find(i => i.id == n).name;
        const arr = res.data.object.boms.filter(i => i.id != n)
        this.BOMLists= arr.map(i =>({
            label:i.name,
            value:itemTabList.find(j => j.id == i.id).tableId
          })).filter(i => i.value != 4);
      });
    },

    copyData(){

      if (!this.BOMSelected) {
        this.$message({
          type: "error",
          message: "请选择需要被Copy的BOM",
        });
        return
      }
      const arr = this.$refs.xGrid.getCheckboxRecords();
      let list = [];
      arr.map(i => {
        if (!arr.some(j => j.serial == i.parentSerial)) {
          list.push(i)
        } 
      })
      let getBOMId = (list) =>{
        const l = arr.map(i => i.serial);
        let fun = (list) => {
          let arr1 = list.map((i) => {
            if (l.includes(i.serial)) {
              // console.log(i.parentRowId.includes(';'));
              let arr = (i.parentRowId+'').split(';').map(Number);
              arr.pop()
              let n = {
                bomId:i.rowId,
                childBomId:[],
                parentRowIdList:arr
              }
              if (i.children?.length) {
                n.childBomId =  fun(i.children);
              }
              return n
            }
          });
          return arr1;
        };
        return fun(list);
      };
      const bomIds = getBOMId(list);
      console.log(bomIds);
      let obj = {
        bomIds ,
        rootId : this.$store.state.objectId.id+'',
        isTree : this.checkList.indexOf("isTree") < 0? 0 : 1,
        isCreate : this.isCreate == 1? 1 : 0,
        isOld :  this.isCreate == 1? 1 : 0,
        tableId : this.BOMSelected, 
        oldTableId : this.$store.state.boms_table_id,
        changeId : 0,
      };
      // return
      this.moreBOMLoading = true;
      axios.post('/pmdm/MultipleBom/copyTable',obj).then(res =>{
        console.log(res);
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: res.data.message,
          });
          this.getMoreBOM();
        }
      })
    },

    selectAllEvent({$table,checked}){
      this.noChecked = !checked;
      let arr = this.getAllRow(this.gridOptions.data);
      for (var row of arr) {
        $table.setCheckboxRow(row, checked);
      }
    },
    setCheck({ $table }){
      
      let arr = this.$refs.xGrid.getCheckboxRecords();
      this.noChecked = !arr.length;
      arr.map(i => {
        if (arr.some(j => j.serial == i.grandParentSerial)) {
          const row = this.getAllRow(this.gridOptions.data).find(k =>k.serial == i.parentSerial );
          $table.setCheckboxRow([row], true);
        }
      })
    },
   
    formatData(arr,level,parentRowId) {
      let newArr = [];
      let serial = level || "";
      parentRowId = parentRowId || "";
      arr.map((i,e) => {

        const s = e + 1 + "";
        let n = {
          rowId : i.rowId,
          parentRowId : !parentRowId ? i.rowId : parentRowId +";"+ i.rowId,
          grandParentSerial : !serial.includes(".") ? '' : serial.substring(0,serial.lastIndexOf('.')),
          serial : !serial ? s : serial + "." + s,
          parentSerial : serial
        };

        console.log(this.gridOptions.columns);

        i.cells.map((j,e) =>{
          // const val = j?.val || '';
          const field = this.gridOptions.columns[e+1]?.field
          if (field) {
            n[field] = j?.val || '';
          }
          // Object.assign(n,{[this.gridOptions.columns[e+1].field]:val})
        });
        newArr.push(n);
        n.children = !i.children ? [] : this.formatData(i.children,n.serial,n.parentRowId);
      });
      return newArr;
    },

  },
  created() {
    this.gridOptions.columns = this.baseGridOptions.columns;
    this.copyBOMGridOptions.columns = this.baseGridOptions.columns;
    this.getBaseBOM();
    this.getBOMList();
    
  },
};
</script>

<style scoped>
.checkbox-group{
  height: 32px;
  line-height: 32px;
  display: inline-block;
  margin-left: 35px;
  margin-bottom: 5px;
}
.content {
  border: 1px solid steelblue;
}
.container {
  width: 100%;
  display: flex;
  flex-wrap: warp;
  justify-content : flex-start;
  /* overflow: hidden; */
  /* border: 1px solid steelblue; */
}
.container  {
  background-color: #fff;
  margin-right: 10px; 
  float: left;
  width: 100%;
}

.left {
  width: 46%;
  height: 500px;
  /* border-right: 1px solid steelblue; */
  display: inline;
  /* float: left; */
}
.mid-button {
  width: 8%;
  height: 500px;
  /* display: inline; */
  /* margin: 0 5px; */
  display: flex;/*父元素设置flex属性*/
    justify-content: center;/*水平主轴居中*/
    align-items: center;/*垂直交叉轴居中*/
} 
.center-button{
  margin: auto;
}

.right {
  width: 46%;
  height: 500px;
  /* display: inline; */
}
.button {
  margin: auto;
  /* height: 15px; */
}
.BOM-title{
  display: inline;
  font-size: 16px;
  color: #409EFF;
}

</style>
